/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VideoThumbnailUrlDTO } from './videoThumbnailUrlDTO';


/**
 * A class that represents the information of a video.  Attributes:  video_id: The video ID.  title: The title of the video.  description: The description of the video.  date: The datetime when the video was uploaded in the SQL format \"YYYY-MM-DD HH:MM:SS\".  duration: The duration of the video in seconds.  offset_seconds: The starting time in seconds in which the video stream should start.  media_urls: A dictionary that contains the video URLs. the keys are the resolution of the video and the values are the URLs of the video. E.g: {\'720p\': \'https://example.com/video.mp4\', \'1080p\': \'https://example.com/video_1080p.mp4\'}  thumbnail_urls: The thumbnail URL of the video.
 */
export interface VideoInfoDTO { 
    title: string;
    description: string;
    gender: VideoInfoDTO.GenderEnum;
    category: string;
    competition: string;
    championship: string;
    video_id: string;
    date: string;
    duration_in_seconds: number;
    available_resolutions: Array<string>;
    status?: VideoInfoDTO.StatusEnum;
    media_urls: { [key: string]: string; };
    thumbnail_urls: VideoThumbnailUrlDTO;
}
export namespace VideoInfoDTO {
    export type GenderEnum = 'FEMENINO' | 'MASCULINO' | 'MIXTO' | 'NO ESPECIFICADO';
    export const GenderEnum = {
        Femenino: 'FEMENINO' as GenderEnum,
        Masculino: 'MASCULINO' as GenderEnum,
        Mixto: 'MIXTO' as GenderEnum,
        NoEspecificado: 'NO ESPECIFICADO' as GenderEnum
    };
    export type StatusEnum = 'PENDING' | 'UPLOADING' | 'PROCESSING' | 'READY' | 'FAILED' | 'DELETED' | 'ARCHIVED' | 'RETIRED';
    export const StatusEnum = {
        Pending: 'PENDING' as StatusEnum,
        Uploading: 'UPLOADING' as StatusEnum,
        Processing: 'PROCESSING' as StatusEnum,
        Ready: 'READY' as StatusEnum,
        Failed: 'FAILED' as StatusEnum,
        Deleted: 'DELETED' as StatusEnum,
        Archived: 'ARCHIVED' as StatusEnum,
        Retired: 'RETIRED' as StatusEnum
    };
}


